/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { App } from 'store/App/types';
import { IApiList, IPaymentSet } from '../../../types';
import { Payments } from './types';

const initialState: IApiList<IPaymentSet> | null = null;

export const paymentsReducer: Reducer<IApiList<IPaymentSet> | null> = (state = initialState, action) => {
  switch (action.type) {
    case App.SET_CURRENT_SITE:
    case Payments.GET_SITE_PAYMENTS_REQUEST: {
      return initialState;
    }
    case Payments.GET_SITE_PAYMENTS_SUCCESS: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};
